import React from "react"
import { Section, Wrapper, FadeBottom } from "./styles"
import Header from "../Header/Header"
import Back from "../Buttons/Back"
import { Link } from "gatsby"
import { entries } from "lodash"

type Props = {
  children: React.ReactNode,
  en?: boolean
}

const Container: React.FC<Props> = ({ children, en }): JSX.Element => {
  return (
    <Section>
      <Wrapper>
        <Header />
        <Link to={en ? "/en" : "/pl"} style={{display: "contents"}}>
          <Back title={en ? " Back" : "Powrót"} en={en} />
        </Link>
        {children}
      </Wrapper>
      {/* <FadeBottom /> */}
    </Section>
  )
}

export default Container
